import React from "react";
import { Tooltip } from "xsolla-uikit";
export const ChatTrigger = ({ shown, handle }) => {
  return (<div id="xsb_how_open" data-a="trigger" className={`xsb_how_trigger ${shown ? "shown" : ""}`} onClick={handle}>
    <Tooltip label="Help and resources">
      <div style={{
        position: "relative",
        height: "64px",
        width: "64px",
        zIndex: 2,
        top: -10,
        left: 0,
      }} />
    </Tooltip>
    <div data-a="target" className="xsb_how_trigger_icon" style={{
      position: "absolute",
    }}>
      <div>chat_bubble_outline</div>
    </div>
  </div>);
};
